import Parser from 'html-react-parser';
import { useAEMResource, useCssReady } from '@hooks';

const Footer = () => {
  const {
    footer,
    footerLoaded,
    footerCssReady,
  } = useAEMResource();
  const globalCssReady = useCssReady(footerLoaded && Boolean(footer));
  const cssReady = globalCssReady && footerCssReady;

  if (!footerLoaded || !footer || !cssReady) {
    return null;
  }

  try {
    return <>{Parser(footer)}</>;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Footer render error:', error);

    return null;
  }
};

export { Footer };
